<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Autenticación</h3>

                  <fg-input v-model="userInput" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Usuario / Email"></fg-input>

                  <fg-input v-model="passwordInput" addon-left-icon="nc-icon nc-key-25" placeholder="Contraseña"
                            type="password" ></fg-input>
                  <!-- <br> -->
                  <!-- TODO acá se debería mostrar la opción de mantenerme logueado -->
                  <!-- <p-checkbox>
                    Subscribe to newsletter
                  </p-checkbox> -->
                  <p-button native-type="submit" slot="footer" type="ingeo" round block class="mb-3" @click="login()">Ingresar</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <!-- TODO cambiar fondo de login -->
        <div class="full-page-background" style="background-image: url(static/img/background/fdohome.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import userService from '../../../services/user'
  import swal from 'sweetalert2'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    methods: {
      loginError(error) {
        var mensajeLogin = ''
        var mensajeUnauthorized = ''
        var mensajePassword = ''
        if (error.errors) {
          if (error.errors.login) {
            // mensajeLogin = error.errors.login[0]
            mensajeLogin = 'El campo Usuario / Email es obligatorio.'
          }
          if (error.errors.password) {
            // mensajePassword = error.errors.password[0]
            mensajePassword = 'El campo Contraseña es obligatorio.'
          }
        } else {
          mensajeUnauthorized = error.message
        }
        swal({
            title: `Error!`,
            html: mensajeLogin + '<br>' + mensajePassword + '<br>' + mensajeUnauthorized,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-danger btn-fill',
            type: 'error'
          })
      },
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login() {
        userService.login(this.userInput, this.passwordInput).then(res => {
            this.$router.push({path: '/'})
        }).catch(
            (error) => this.loginError(error.response.data)
        )
      },
    },
    data() {
      return {
        userInput: '',
        passwordInput: ''
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
